import React from 'react';
import { render } from 'react-dom';
import PdfCartApplication from './pdf-cart/main/pdfCart.application';
import PresentationCartApplication from './presentation-cart/main/presentationCart.application';
import BrochurePDFCartApplication from './brochure-cart/main/pdfCart.application';

render(<PdfCartApplication />, document.getElementById('pdf-cart-root'));
render(<PresentationCartApplication />, document.getElementById('presentation-cart-root'));
render(<BrochurePDFCartApplication />, document.getElementById('brochure-pdf-cart-root'));
